<template>
  <div class="path-not-found">
    <h1>404</h1>
  </div>
</template>

<script>
  export default {
    name: 'PathNotFoundView',
  }
</script>

<style lang="sass">
.path-not-found
  height: 400px
  background: repeating-linear-gradient(-15deg, #ec408a, #ec407a 10px, #000 5px, #465298 20px)
  background-size: 100% 0.25vw
  h1
    resize: both
    margin: 0
    padding: 0
    font-size: 16vw
    alight: center
</style>
